
export const ScheduleConstants = {
    INPROGRESS: 'In Progress',
    VERIFY: 'Verify',
    VERIFIED: 'Verified',
    COMPLETED: 'Completed'
}
export const geti18nStatusText = (status, i18n) => {
    switch (status) {
        case ScheduleConstants.INPROGRESS: return i18n.schedule.inProgress; break;
        case ScheduleConstants.VERIFY: return i18n.schedule.verify; break;
        case ScheduleConstants.VERIFIED: return i18n.schedule.verified; break;
        case ScheduleConstants.COMPLETED: return i18n.schedule.completed; break;
        default: return
    }

}